module.exports = __webpack_public_path__ + "static/media/folder.e4a36317.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/folder.svg
// module id = 746
// module chunks = 0